import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { BrandingService } from '../services/branding.service';

@Injectable({
  providedIn: 'root',
})
export class BrandingGuard implements CanActivate {
  constructor(private readonly brandingService: BrandingService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const branding = route.queryParamMap.get('branding');
    this.brandingService.load(branding);

    return true;
  }
}
